<template>
    <div class="warehouse_section">
        <i class="uis uis-building"></i>
        <h2>Warehouse</h2>
        <h2>This section is under construction</h2>
    </div>
</template>

<script>
export default {

}
</script>

<style>
.warehouse_section {
    padding-top: 2rem;

    i {
        font-size: 2rem;
    }
}
</style>